import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, Button, Card, Container, Alert } from 'react-bootstrap';
import { authAPI } from '../../utils/api';
import { useTranslation } from '../../i18n';
import { translateBackendMessage } from '../../utils/translateMessage';
import styles from './Auth.module.css';

const validationSchema = Yup.object({
  email: Yup.string()
    .email('כתובת דואר אלקטרוני לא תקינה')
    .required('שדה חובה')
});

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: ''
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        setError(null);
        await authAPI.forgotPassword(values.email);
        setSuccess(true);
      } catch (err) {
        const rawMessage = err.response?.data?.message;
        const translated = translateBackendMessage(rawMessage);
        setError(translated || rawMessage || t('notifications.frontend.auth.forgotPasswordError'));
      } finally {
        setLoading(false);
      }
    }
  });

  if (success) {
    return (
      <Container className={styles.authContainer}>
        <Card className={styles.authCard}>
          <Card.Body>
            <h2 className={styles.authTitle}>{t('ui.auth.resetPasswordTitle')}</h2>
            <Alert variant="success">
              {t('ui.auth.forgotSuccess')}
            </Alert>
            <div className={styles.authLinks}>
              <Link to="/login">{t('ui.auth.backToLogin')}</Link>
            </div>
          </Card.Body>
        </Card>
      </Container>
    );
  }

  return (
    <Container className={styles.authContainer}>
      <Card className={styles.authCard}>
        <Card.Body>
          <h2 className={styles.authTitle}>{t('ui.auth.forgotPasswordTitle')}</h2>
          
          {error && (
            <Alert variant="danger" className="mb-4">
              {error}
            </Alert>
          )}

          <p className="text-center mb-4">
            {t('ui.auth.forgotPasswordDescription')}
          </p>

          <Form onSubmit={formik.handleSubmit}>
            <Form.Group className="mb-4">
              <Form.Label>{t('ui.auth.email')}</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                isInvalid={formik.touched.email && formik.errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {formik.errors.email}
              </Form.Control.Feedback>
            </Form.Group>

            <Button
              variant="primary"
              type="submit"
              className="w-100 mb-4"
              disabled={loading}
            >
              {loading ? t('ui.auth.forgotPasswordSubmitting') : t('ui.auth.sendResetInstructions')}
            </Button>

            <div className={styles.authLinks}>
              <Link to="/login">{t('ui.auth.backToLogin')}</Link>
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default ForgotPassword; 